var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-proposal-logs"},[_c('h2',[_vm._v("История заявки")]),_c('div',{ref:"items",staticClass:"items"},_vm._l((_vm.proposalLogs),function(item){return _c('SingleLog',{key:item.createTime,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }